class UserSearchInlineInputListener extends AbstractInputListener
{

    listen()
    {
        let context = this;
        $(document).on('keydown', context.selector, function (){


            console.log('User search inline input keydown');

        });



    }

}